import { connect } from 'react-redux'
import { IGlobalState } from '../../Root/store/appReducer'
import { createGoal, resetSubmitInProgress, updateGoal } from './store/ChallengeAdminActions'
import { hasRoleInCompany } from '../../common/auth/authSelectors'
import ChallengeAdmin, { IChallengeAdminDispatchProps } from './ChallengeAdmin'
import { getUserGoals } from '../Activity/store/ActivitySelectors'
import { getCurrentCompanyGoal } from '../Activity/store/ActivityActions'
import { CompanyId, Role } from '../../services/api.types'
import {
  companyCountriesSelector,
  managedCompaniesSelector,
  userCompaniesSelector,
  userDtoSelector,
} from '../Settings/store/SettingsSelectors'
import { getDivisionCategories } from '../TeamManagement/store/TeamManagementActions'
import { getDivisionCategories as getDivisionCategoriesSelector } from '../TeamManagement/store/TeamManagementSelectors'

const mapStateToProps = (state: IGlobalState, ownProps: any) => {
  const goalId = ownProps.match.params.goalId
  return {
    goalId,
    managedCompanies: managedCompaniesSelector(state),
    userCompanies: userCompaniesSelector(state),
    // goals: goalId ? getUserGoals(state) : [],
    goals: getUserGoals(state),
    userDto: userDtoSelector(state),
    divisionCategories: getDivisionCategoriesSelector(state),
    companyCountries: companyCountriesSelector(state),
    submitInProgress: state.challengeAdmin.submitInProgress,
    //hasRoleInCompany: (companyId: CompanyId, role: Role) => hasRoleInCompany(state, companyId, role),
  }
}

const mapDispatchToProps: IChallengeAdminDispatchProps = {
  createGoal,
  updateGoal,
  getCurrentCompanyGoal,
  getDivisionCategories,
  resetSubmitInProgress,
}

export default connect(mapStateToProps, mapDispatchToProps)(ChallengeAdmin)
